/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FolderFile { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    /**
     * Nombre original del archivo
     */
    originalName: string;
    /**
     * Nombre del archivo en el sistema
     */
    fileName: string;
    /**
     * URL del archivo
     */
    url: string;
    /**
     * Ruta física del archivo
     */
    path: string;
    folderId: string;
    userId?: number;
    companyId?: string;
    /**
     * Módulo dueño del archivo. null = módulo de documentos; \"normativity\" = módulo de normatividad
     */
    moduleKey?: string;
    /**
     * Indica si el archivo está cifrado en reposo. Las filas previas quedan en false
     */
    isEncrypted?: boolean;
    /**
     * IV de EncryptionService, requerido para descifrar en la descarga segura
     */
    encryptionIv?: string;
    /**
     * Auth tag de AES-GCM
     */
    encryptionAuthTag?: string;
    /**
     * SHA-256 del archivo en claro: prueba que el archivo publicado no fue alterado
     */
    checksum?: string;
    encryptedDek?: string;
    dekIv?: string;
    dekAuthTag?: string;
    keyVersion?: number;
    /**
     * Orden de visualización dentro de la carpeta
     */
    displayOrder?: number;
    parentFileId?: string;
}

